import React, { useState, useEffect } from 'react';
import {
    Card, CardHeader, Divider, CardContent, TextField, TableContainer, Button,
    Table, TableHead, TableRow, TableCell, TableBody, IconButton, Tooltip,
    Grid, Container, Backdrop, CircularProgress, Snackbar, TablePagination,
    Typography, Paper
} from '@material-ui/core';
import axios from 'src/utils/axios';
import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete } from '@mui/material';
import Alert from 'src/components/Alert';
import Page from 'src/components/Page';
import { makeStyles } from '@material-ui/core/styles';
import { PatternFormat } from "react-number-format";
import { getUser } from 'src/utils/Common';
import { confirmAlert } from 'react-confirm-alert';


const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
    },
    backdrop: {
        zIndex: 9999,
        color: '#fff',
    },
    mainContainer: {
        paddingTop: theme.spacing(3)
    }
}));

function SearchWorkOrder() {
    const classes = useStyles();
    const SessionUser = getUser();

    const [mainData, setMainData] = useState([]);

    const [nameInput, setNameInput] = useState('');
    const [surnameInput, setSurnameInput] = useState('');
    const [phoneInput, setPhoneInput] = useState('');

    const [cityInput, setCityInput] = useState([]);
    const [districtInput, setDistrictInput] = useState([]);
    const [neighborhoodInput, setNeighborhoodInput] = useState([]);

    const [selectedCityInput, setSelectedCityInput] = useState(null);
    const [selectedDistrictInput, setSelectedDistrictInput] = useState(null);
    const [selectedNeighborhoodInput, setSelectedNeighborhoodInput] = useState(null);

    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });

    useEffect(() => {
        axios.get('/GetWorkOrderCities')
            .then(response => {
                setCityInput(response.data);
            })
            .catch(error => {
                setCityInput([]);
            });
    }, []);

    const handleCityChange = (event, newValue) => {
        setSelectedCityInput(newValue);

        if (newValue) {
            const cityName = newValue.IL;

            axios.get(`/GetWorkOrderDistrictsFromCity/${cityName}`)
                .then(response => {
                    setDistrictInput(response.data);
                })
                .catch(error => {
                    setDistrictInput([]);
                });

        } else {
            setDistrictInput([]);
            setSelectedDistrictInput([]);
            setNeighborhoodInput([]);
            setSelectedNeighborhoodInput([]);
        }
    };

    const handleDistrictChange = (event, newValue) => {
        setSelectedDistrictInput(newValue);

        if (newValue) {
            const cityName = selectedCityInput.IL;
            const districtName = newValue.ILCE_AD;

            axios.get(`/GetWorkOrderNeighborhood/${cityName}/${districtName}`)
                .then(response => {
                    setNeighborhoodInput(response.data);
                })
                .catch(error => {
                    setNeighborhoodInput([]);
                });

        } else {
            setNeighborhoodInput([]);
            setSelectedNeighborhoodInput([]);
        }
    };

    const handleSearch = () => {
        setLoading(true);
        const data = {
            Name: nameInput || '0',
            Surname: surnameInput || '0',
            Phone: phoneInput || '0',
            City: selectedCityInput.IL || '0',
            District: selectedDistrictInput.ILCE_AD || '0',
            Neighborhood: selectedNeighborhoodInput.MAHALLE || '0',
            SessionTokenWs: SessionUser?.SessionTokenWs
        };

        axios.get(`/SearchWorkOrder/${data.Name}/${data.Surname}/${data.Phone}/${data.City}/${data.District}/${data.Neighborhood}/${data.SessionTokenWs}`)
            .then(response => {
                const data = response.data.getIntheBoxResponse;
                setMainData(data);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const handleCancelOrder = (packageNr, rowId) => {

        confirmAlert({
            message: 'İş emri pasife alındıktan sonra tekrar aktife çekilemez. İş emrini pasife almak istediğinize emin misiniz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {

                        setLoading(true);
                        const data = {
                            PackageNumber: parseInt(packageNr),
                            RowNumber: parseInt(rowId)
                        };

                        axios.post('/CancelWorkOrder', data).then(response => {
                            if (response.data.ErrorCode === '0') {
                                handleSearch();

                                setUyariTip('success');
                                setresponseMessage(response.data.ErrorDescription);
                                setUyari(true);
                            }
                            else {
                                setUyariTip('error');
                                setresponseMessage(response.data.ErrorDescription);
                                setUyari(true);
                            }
                            setLoading(false);
                        }).catch(error => {
                            setUyariTip('error');
                            setresponseMessage('İşlem sırasında bir hata oluştu!');
                            setUyari(true);
                            setLoading(false);
                        });

                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => { }
                }
            ]
        });


    }


    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    return (
        <Page className={classes.root}>
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={uyari}
                autoHideDuration={10000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage}
                ></Alert>
            </Snackbar>
            <Container className={classes.mainContainer} maxWidth="xl">
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                        <Card>
                            <CardHeader title="İş Emri Sorgula" />
                            <Divider />
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            label="Adı"
                                            fullWidth
                                            variant="standard"
                                            value={nameInput}
                                            onChange={(e) => setNameInput(e.target.value)}
                                            inputProps={{ maxLength: 100 }}
                                            helperText={`${nameInput.length}/100`}
                                            FormHelperTextProps={{ style: { textAlign: "right", width: "100%", fontSize: '0.8rem' } }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            label="Soyadı"
                                            fullWidth
                                            variant="standard"
                                            value={surnameInput}
                                            onChange={(e) => setSurnameInput(e.target.value)}
                                            inputProps={{ maxLength: 100 }}
                                            helperText={`${surnameInput.length}/100`}
                                            FormHelperTextProps={{ style: { textAlign: "right", width: "100%", fontSize: '0.8rem' } }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <PatternFormat
                                            format="(###) ### ## ##"
                                            value={phoneInput}
                                            onValueChange={(values) => setPhoneInput(values.value)}
                                            mask="_"
                                            customInput={TextField}
                                            label="Telefon"
                                            fullWidth
                                            variant="standard"
                                            helperText={`${phoneInput.length}/10`}
                                            FormHelperTextProps={{ style: { textAlign: "right", width: "100%", fontSize: '0.8rem' } }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Autocomplete
                                            value={selectedCityInput}
                                            onChange={(event, newValue) => { handleCityChange(event, newValue); }}
                                            options={cityInput}
                                            getOptionLabel={(option) => option.IL || ''}
                                            renderInput={(params) => <TextField {...params} label="İl" variant="standard" fullWidth />}
                                            sx={{
                                                '& .MuiAutocomplete-endAdornment': {
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Autocomplete
                                            value={selectedDistrictInput}
                                            onChange={(event, newValue) => { handleDistrictChange(event, newValue); }}
                                            options={districtInput}
                                            getOptionLabel={(option) => option.ILCE_AD || ''}
                                            renderInput={(params) => <TextField {...params} label="İlçe" variant="standard" fullWidth />}
                                            sx={{
                                                '& .MuiAutocomplete-endAdornment': {
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Autocomplete
                                            value={selectedNeighborhoodInput}
                                            onChange={(event, newValue) => { setSelectedNeighborhoodInput(newValue); }}
                                            options={neighborhoodInput}
                                            getOptionLabel={(option) => option.MAHALLE || ''}
                                            renderInput={(params) => <TextField {...params} label="Mahalle" variant="standard" fullWidth />}
                                            sx={{
                                                '& .MuiAutocomplete-endAdornment': {
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Typography variant="subtitle2">
                                            <b>DİKKAT:</b> 25/07/2019 tarihinden önceki iş emirlerini sorgulamak için telefon numarası girilmesi gerekmektedir.
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            fullWidth
                                            sx={{ marginTop: 2 }}
                                            startIcon={<SearchIcon />}
                                            onClick={() => { handleSearch(); }}
                                        >
                                            SORGULA
                                        </Button>
                                    </Grid>

                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Card>
                            <CardHeader title="İş Emri Listesi" />
                            <Divider />
                            <CardContent>
                                <Grid container spacing={2}>
                                    <TableContainer component={Paper}>
                                        <Table size='small'>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align='center'>Paket Numarası</TableCell>
                                                    <TableCell align='center'>Ad Soyad</TableCell>
                                                    <TableCell align='center'>Telefon</TableCell>
                                                    <TableCell align='center'>İl</TableCell>
                                                    <TableCell align='center'>İlçe</TableCell>
                                                    <TableCell align='center'>Mahalle</TableCell>
                                                    <TableCell align='center'>Adres</TableCell>
                                                    <TableCell align='center'>Ürün</TableCell>
                                                    <TableCell align='center'>Servis Noktası</TableCell>
                                                    <TableCell align='center'>Durum</TableCell>
                                                    <TableCell align='center'>İşlem</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {mainData.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align='center'>{row.packageNr || '-'}</TableCell>
                                                        <TableCell align='center'>{row.name} {row.surname}</TableCell>
                                                        <TableCell align='center'>{row.phone || '-'}</TableCell>
                                                        <TableCell align='center'>{row.city || '-'}</TableCell>
                                                        <TableCell align='center'>{row.district || '-'}</TableCell>
                                                        <TableCell align='center'>{row.neighborhood || '-'}</TableCell>
                                                        <TableCell align='center'>{row.address || '-'}</TableCell>
                                                        <TableCell align='center'>{row.product || '-'}</TableCell>
                                                        <TableCell align='center'>{row.serviceShopCode || '-'}</TableCell>
                                                        <TableCell align='center'>{row.status || '-'}</TableCell>
                                                        <TableCell align='center'>
                                                            <Button
                                                                variant="contained"
                                                                color="secondary"
                                                                size='small'
                                                                fullWidth
                                                                onClick={() => { handleCancelOrder(row.packageNr, row.rowId); }}
                                                            >
                                                                İptal Et
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
};

export default SearchWorkOrder;
